import React from 'react';
import ProtectedPageSidebar from '../../components/Sidebar/ProtectedPageSidebar';
import SubtitlesEditorContent from '../../features/SubtitlesEditor';

const SubtitlesEditor = props => {
  return (
    <>
      <ProtectedPageSidebar />
      <SubtitlesEditorContent {...props} />
    </>
  );
};

export default SubtitlesEditor;
